export default __webpack_public_path__ + "static/media/embed_dashboard_demo.3ce96716.png";